import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

export function Eyebrow({ children, className }: EyebrowProps) {
  return (
    <p className={cn("text-accent text-[13px] font-bold tracking-[0.08em] uppercase", className)}>
      {children}
    </p>
  );
}
